import './styles/NotFoundPage.scss';

import { Grid, Typography } from '@mui/material';

import { Helmet } from 'react-helmet-async';

import Title from 'app/containers/Dashboard/Login/components/Title';
import usePageHeading from 'utils/hooks/usePageHeading';

export function NotFoundPage() {
  usePageHeading('');

  return (
    <>
      <Helmet>
        <title>404 Page Not Found</title>
        <meta name="description" content="Page not found" />
      </Helmet>
      <Grid container className="wrapper">
        <Grid item>
          <Title className="title">
            4
            <span role="img" aria-label="Crying Face">
              😢
            </span>
            4
          </Title>
        </Grid>
        <Grid item>
          <Typography>Page not found.</Typography>
        </Grid>
      </Grid>
    </>
  );
}
